<template>
  <transition name="fade">
    <perfect-scrollbar class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <h4>Set Pricing</h4>
        <div class="tabCnt">
          <div class="tab tab1" :class="{active: tabActive === 'multiple'}"
            v-on:click="selectTab('multiple')">Multiple Price</div>
          <div class="tab tab1" :class="{active: tabActive === 'single'}"
            v-on:click="selectTab('single')">Same Price</div>
        </div>
        <div class="tabContent" v-if="tabActive === 'multiple'">
          <div v-for="(item, i) in d" :key="`mp${i}`">
            <div class="fieldGroup fgc" v-if="item.checked">
              <div class="productItem">
                <div class="saved" v-if="item.saved"></div>
                <div class="thumb" v-if="item.images.length > 0 && item.images[0].media"
                  :style="{'background-image': `url(${item.images[0].media.imageSm})`}">
                </div>
                <div class="thumb noImg" v-else></div>
                <h4>{{item.name}}</h4>
                <p v-if="item.sellPrice">Current price: Rp
                  {{item.sellPrice.toLocaleString('id')}}</p>
                <p v-else>Current price: Rp 0</p>
              </div>
              <div class="fieldCnt">
                <input type="number" class="field hasPrefix"
                  placeholder="New price..." v-model="item.newPrice">
                <div class="fieldPrefix noLabel">Rp</div>
              </div>
            </div>
          </div>
        </div>
        <div class="tabContent" v-else-if="tabActive === 'single'">
          <div class="singleInfo">
            <h4>Same Price</h4>
            <p>This will update the same price to all selected products</p>
          </div>
          <div class="fieldGroup">
            <div class="fieldCnt">
              <input type="number" class="field hasPrefix"
                placeholder="New price..." v-model="newPrice">
              <div class="fieldPrefix noLabel">Rp</div>
            </div>
          </div>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" type="button"
            v-on:click="close(false)">Cancel</button>
          <button class="btn btnPrimary" type="submit"
            :class="{btnLoading: loading}"
            v-on:click="handleSubmit">
            <span>Save Changes</span>
          </button>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <AddDonationBudget ref="addDonationBudget"/>
      <AddDonationExpenses ref="addDonationExpenses"/>
    </perfect-scrollbar>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import AddDonationBudget from '@/components/AddDonationBudget.vue';
import AddDonationExpenses from '@/components/AddDonationExpenses.vue';

export default {
  components: { Confirmation, AddDonationBudget, AddDonationExpenses },
  data() {
    return {
      d: [],
      show: false,
      next: null,
      loading: false,
      expenses: [],
      tabActive: 'multiple',
      newPrice: '',
    };
  },
  methods: {
    open(d, n) {
      this.d = d;
      this.tabActive = 'multiple';
      this.loading = false;
      this.next = n;
      this.show = true;
      // eslint-disable-next-line
      for (const item of this.d) {
        // eslint-disable-next-line
        item.saved = false;
      }
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    async handleSubmit() {
      this.loading = true;
      // eslint-disable-next-line
      for (const item of this.d) {
        if (item.checked) {
          let newPrice;
          if (this.tabActive === 'multiple') newPrice = Number(item.newPrice);
          else newPrice = Number(this.newPrice);
          if (!newPrice) newPrice = 0;
          // eslint-disable-next-line
          item.saved = true;
          // eslint-disable-next-line
          await this.$http.post(this.$config.uri(`product/${item.id}/price`), {
            price: newPrice,
          });
          // eslint-disable-next-line
          item.sellPrice = newPrice;
        }
        this.close(true, this.d);
      }
    },
    selectTab(tab) {
      this.tabActive = tab;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: #000;
      opacity: .7;
      z-index: 1;
    }
    .fieldGroup.fgc{
      display: flex;
      align-items: center;
      margin: 0;
      padding: 8px 0;
      border-bottom: #eee 1px dashed;
      .productItem{
        width: calc(100% - 160px);
        position: relative;
        min-height: 48px;
        padding-left: 64px;
        padding-top: 3px;
        box-sizing: border-box;
        .saved{
          position: absolute;
          width: 16px; height: 16px;
          border-radius: 50%;
          background-color: green;
          left: -5px; top: -5px;
          background-image: url(../assets/checked.png);
          background-size: 10px auto;
          background-position: center;
          background-repeat: no-repeat;
          z-index: 7;
        }
        h4{
          margin: 0;
          font-size: 17px;
          font-weight: normal;
          white-space: normal;
          span{
            background: #777;
            color: #fff;
            font-size: 15px;
            padding: 2px 7px;
            border-radius: 3px;
            margin-left: 10px;
            margin-top: 5px;
          }
        }
        p{
          margin: 0;
          white-space: normal;
          font-size: 15px;
          color: #767676;
        }
        .thumb{
          left: 0;
          top: 0;
          position: absolute;
          width: 48px;
          height: 48px;
          // height: 80px;
          // top: 20px;
          background-color: #e5e5e5;
          // background-color: #fff;
          background-size: cover;
          background-position: top center;
          background-repeat: no-repeat;
          border-radius: 4px;
          opacity: 1;
          display: inline-block;
          &.noImg{
            background-image: url(../assets/image-white.png);
            background-size: 24px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          .prizeMore{
            color: #fff;
            font-size: 12px;
            position: absolute;
            right: 10px; bottom: 10px;
          }
        }
      }
      .fieldCnt{
        width: 160px;
        // text-align: right;
        .field{
          text-align: right;
        }
      }
    }
    .modalContent{
      position: relative;
      background-color: #fff;
      z-index: 2;
      padding: 30px 60px;
      border-radius: 5px;
      overflow: hidden;
      max-width: none;
      width: 640px;
      box-sizing: border-box;
      // top: 50%; left: 50%;
      // transform: translate(-50%, -50%);
      margin: 40px auto;
      .close{
        position: absolute;
        right: 15px; top: 15px;
        border-radius: 50%;
        width: 30px; height: 30px;
        background-image: url(../assets/close.png);
        background-size: 12px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        opacity: .5;
        &:hover{
          opacity: .8;
          background-color: #fff;
        }
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      .subtitle{
        color: #767676;
        margin: -11px 0 20px;
      }
      .loading{
        height: 300px;
        background-image: url(../assets/loading-2.svg);
        background-size: 46px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      .tabCnt{
        margin: 0;
        .tab{
          text-align: left;
          padding-left: 0;
          padding-right: 0;
          width: 50%;
          background-color: #fff;
        }
      }
      .tabContent{
        margin: 0 -60px;
        padding: 10px 60px 0;
        // max-height: 500px;
        // overflow-y: auto;
        .singleInfo{
          padding: 6px 0 20px;
          h4{
            margin: 0;
            font-size: 20px;
          }
          p{
            color: #767676;
            font-size: 15px;
          }
        }
      }
      .modalAction{
        margin: 30px -60px -30px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        .deleteCat{
          position: absolute;
          left: 30px; top: 22px;
          color: red; cursor: pointer;
          padding-left: 22px;
          opacity: .8;
          &:before{
            display: block;
            content: "";
            position: absolute;
            left: 0; top: 0;
            width: 16px; height: 20px;
            background-image: url(../assets/delete.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            opacity: 1;
          }
        }
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
